import { createApi } from '@reduxjs/toolkit/query/react';

import fetchBaseQuery from '../fetchBaseQuery';

export type Filename = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    filename_id: string;
    filename: string;
};

export type GetFilenamesResponse = {
    err: 1 | 0;
    data: Filename[];
};

export type GetTagsResponse = {
    tags: string[];
};

const projectApi = createApi({
    reducerPath: 'projectApi',
    baseQuery: fetchBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        getFilenames: builder.query<GetFilenamesResponse, { projectId: string; branchName?: string }>({
            query: ({ projectId, branchName }) => ({
                method: 'GET',
                url: `/project/${projectId}/filenames${branchName ? `?branch=${branchName}` : ``}`,
            }),
        }),
        getTags: builder.query<GetTagsResponse, { projectId: string; branchName?: string }>({
            query: ({ projectId, branchName }) => ({
                method: 'GET',
                url: `/project/${projectId}/tags${branchName ? `?branch=${branchName}` : ``}`,
            }),
        }),
    }),
});

export default projectApi;

export const { useGetFilenamesQuery, useGetTagsQuery } = projectApi;
